import React, {useState, useEffect} from 'react'
import propTypes from 'prop-types'
import ReactHtmlParser from 'react-html-parser';
import {Grid} from '@mui/material';
import styled from '@emotion/styled';
import Text from '../../../components/typography';
import LinkButton from '../../../components/ui/LinkButton';
import {theme} from '../../../themes/default-theme';
import Cta from '../../../components/ui/Cta';
import { ReactSVG } from 'react-svg';


// icons
import locationIcon from '../../../assets/icons/location-blue.svg';
import emailIcon from '../../../assets/icons/email-blue.svg';
import clockIcon from '../../../assets/icons/clock-blue.svg';
import phoneIcon from '../../../assets/icons/phone-blue-2.svg';
import dlPush from '../../../util/dlPush';
import IconLink from '../../../components/ui/IconLink';

const Contact = styled.div`
  margin: 30px 0;
  padding: 30px 0 0;
  border-top: 1px solid ${theme.palette.middleGrey};
`

const ContactHeading = styled.div`
  margin: 0 0 20px;
`
const Address = styled.address`
  margin-bottom: 15px;
  text-decoration: none;
  font-style: normal;
  padding-left: 40px;
  position: relative;
  padding-right: 20px;
  svg {
    position: absolute;
    top: 3px;
    left: 0;
  }
  ${theme.breakpoints.up('md')} {

  }
`

const OpeningHours = styled.div`
  margin-top: 20px;
  padding-left: 40px;
  position: relative;
  svg {
    position: absolute;
    top: 3px;
    left: 0;
  }
  ${theme.breakpoints.up('md')} {

  }
`

const LinkContainer = styled.div`
  margin-bottom: 25px;
  
  ${theme.breakpoints.down('sm')} {
    margin-top: 25px;
  }
`

const Link = styled.a `
  padding-left: 40px;
  position: relative;

  > div {
    position: absolute;
    top: 2px;
    left: 0;
  }
  svg {

  }
`

const A = styled.a `
  display: block;
  margin-top: 7px;
  text-decoration: none;

  .svg-container {
    background-color: transparent;

    svg {
      width: 18px;
      height: auto;
    }
  }

  ${theme.breakpoints.down('md')} {
    .svg-container svg {
      height: 10px;
      position: relative;
      top: -2px;
    }
  }

  ${props => props.smallIcon === 1 && `
    .svg-container svg {
      height: 10px;

      ${theme.breakpoints.down('md')} {
        height: 8px;
      }
    }
  `}
`

const Ctas = styled.div`
  margin-top: 30px;
  width: 100%;

  a {
    ${props => props.smallPadding ? 'padding: 10px;' : ''}
  }
`

const LinkItem = styled.div`
  width: 100%;
  margin-bottom: 12px;

  ${theme.breakpoints.up('md')} {
  }
`

const CtaItems = styled.div`
    padding-top: 24px;
    margin-top: 24px;
    border-top: 1px solid ${theme.palette.middleGrey};

`

const CtaItem = styled.div`
  margin-bottom: 12px;
  display: inline-block;
  margin-right: 10px;
  min-width: 215px;
    
  a.cta,
  a.cta.MuiButtonBase-root,
  a {
    width: 100%;
    display: block;
    text-align: center;
  }

  ${theme.breakpoints.down('sm')} {
    margin-bottom: 10px;
    width: calc(50% - 10px);
    min-width: auto;
  }

  ${theme.breakpoints.up('md')} {

  }
`


const ContactBtn = styled(LinkButton)`

`

const contactDetailsDefaultPropData = {};
const contactDetailsDefaultPropOnBtnClick = () => {};

const ContactDetails = (props) => {
  props = {
    ...props,
    title: typeof props.title === "undefined" ? 'Contact details' : props.title,
    heading: typeof props.heading === "undefined" ? null : props.heading,
    data: typeof props.data === "undefined" ? contactDetailsDefaultPropData : props.data,
    borderColor: typeof props.borderColor === "undefined" ? theme.palette.lightGrey : props.borderColor,
    dealerBtnText: typeof props.dealerBtnText === "undefined" ? 'Search again' : props.dealerBtnText,
    ctaWidth: typeof props.ctaWidth === "undefined" ? 180 : props.ctaWidth,
    onBtnClick: typeof props.onBtnClick === "undefined" ? contactDetailsDefaultPropOnBtnClick : props.onBtnClick,
    stack: typeof props.stack === "undefined" ? true : props.stack,
    dealerHref: typeof props.dealerHref === "undefined" ? '/find-a-dealer' : props.dealerHref,
    type: typeof props.type === "undefined" ? null : props.type,
    dealer: typeof props.dealer === "undefined" ? null : props.dealer
  };

  const {
    title,
    data,
    heading,
    borderColor,
    dealerBtnText,
    ctaWidth,
    onBtnClick,
    stack,
    dealerHref,
    dealer,
    type
  } = props

  const [viewNumber, setViewNumber] = useState(false);
  const [email, setEmail] = useState(null);
  const [serviceQuery, setServiceQuery] = useState(false);

  // Don't render email to prevent bots from picking up
  useEffect(() => {
    setEmail(data.contact.email);
    const serviceQuery = window.location.search.indexOf('service') !== -1 ? true : false;
    setServiceQuery(serviceQuery);
  }, []);

  useEffect(() => {
    if (viewNumber) {
      dlPush({
        'event': 'jaycoEvent',
        'eventAction': 'Phone Number Reveal',
        'eventCategory': 'Engage',
        'eventLabel': dealer || `tel:${data.contact.phone}`
      })
    }
  }, [viewNumber]);

  const handleViewingClick = () => {
    onBtnClick();
    // dlPush({
    //   'event': 'jaycoEvent',
    //   'eventAction': 'CTA Click - Request a Viewing',
    //   'eventCategory': 'Research',
    //   'eventLabel': type === 'header' ? 'Main nav' : window.location.pathname,
    // })
  }

  const handleEmailClick = (e, email) => {
    e.preventDefault();
    if (typeof(email) === 'string') {
      location.href = "mailto:"+email;
    } else {
      const link = email.join('@');
      location.href = "mailto:"+link;
    }

  }

  return (
    <Contact>
      <ContactHeading>
        {title && <Text variant="h6" colour="black">{title}</Text>}
        {heading && <Text variant="h6" colour="skyBlue" uppercase>{heading}</Text>}
      </ContactHeading>
      <Grid container spacing={0} direction={'row'} justifyContent={'space-between'} alignItems={'flex-start'}>
        <Grid
          size={{
            xs: stack ? 12 : 6,
            md: 7
          }}>
          {data.contact.formattedAddress && 
            <Address>
              <ReactSVG src={locationIcon} />
              <Text variant="body1" colour="gunmentalGrey">
                {data.contact.formattedAddress}<br />
                <a  href={`https://www.google.com/maps/dir/?api=1&destination=${data.location.lat},${data.location.lng}`} target="_blank" >Get Directions</a>
              </Text>
            </Address>
          }
          {data.contact.openingHours &&
            <OpeningHours borderColor={borderColor}>
              <ReactSVG src={clockIcon} />
              <Text variant="body1" colour="gunmentalGrey"><strong>Opening hours</strong></Text>
              <Text variane="body1">{ReactHtmlParser(data.contact.openingHours)}</Text>
            </OpeningHours>
          }

        </Grid>
        <Grid
          size={{
            xs: stack ? 12 : 6,
            md: 5
          }}>
          <Text variant="body1">
            <LinkContainer>
              <Link legacyBehavior href={'#'} onClick={(e) => handleEmailClick(e, email)}>
                <ReactSVG src={emailIcon} />
                Email Dealer
              </Link>
            </LinkContainer>
            <LinkContainer>
              <Link legacyBehavior href={viewNumber ? `tel:${data.contact.phone}` : '#'} onClick={() => setViewNumber(true)}>
                <ReactSVG src={phoneIcon} />
                {viewNumber ? data.contact.phone : 'View phone number'}
              </Link>
            </LinkContainer>
          </Text>
        </Grid>
        

        <Ctas smallPadding={stack ? false : true}>
          {data.service &&
            <LinkItem>
              <IconLink 
                  svg={''}
                  link={{
                      title: 'Request a service',
                      href: '/book-a-service'
                  }}
                  colour={'vividBlue'}
                  onClick={onBtnClick}
              />
            </LinkItem>
          }
          {data.sales && 
            <LinkItem>
                <IconLink 
                  svg={''}
                  link={{
                      title: 'Request a viewing',
                      href: '/book-a-viewing'
                  }}
                  colour={'vividBlue'}
                  onClick={handleViewingClick}
              />
            </LinkItem>
          }

          {data.contact.website &&
            <LinkItem>
                <IconLink 
                  svg={''}
                  link={{
                      title: 'View dealer website',
                      href: data.contact.website.replace('https', 'http'),
                      target: "_blank"
                  }}
                  colour={'vividBlue'}
                  
              />
            </LinkItem>
          }

          <CtaItems>
            <CtaItem>
              <Cta
                inline
                href={viewNumber ? `tel:${data.contact.phone}` : '#'} 
                onClick={() => setViewNumber(true)}
              >
                Call Dealer
              </Cta>
            </CtaItem>
            <CtaItem>
              <Cta
                inline
                outline
                href={'#'} 
                onClick={(e) => handleEmailClick(e, email)}
              >
                Email us
              </Cta>
            </CtaItem>
          </CtaItems>
          {/* {data.service && serviceQuery ?
            <CtaItem width={ctaWidth}>
              <Cta href="/find-a-service-centre" outline onClick={onBtnClick}>{dealerBtnText}</Cta>
            </CtaItem>
          :
          <CtaItem width={ctaWidth}>
            <Cta href={dealerHref} outline onClick={onBtnClick}>{dealerBtnText}</Cta>
          </CtaItem>
          } */}
        </Ctas>
      </Grid>
    </Contact>
  );
}

ContactDetails.propTypes = {
  title: propTypes.string,
  heading: propTypes.string,
  data: propTypes.object,
  borderColor: propTypes.string,
  dealerBtnText: propTypes.string,
  ctaWidth: propTypes.number,
  onBtnClick: propTypes.func,
  stack: propTypes.bool,
  dealerHref: propTypes.string,
  type: propTypes.string,
  dealer: propTypes.string
}

export default ContactDetails